import React from "react";
import "../../assets/css/style.css";
import "./CSS/Wreath.css";
import "./CSS/Medias.css";
import InvitationText from "../InvitationText";

class Wreath extends React.Component {
  constructor(props) {
    super(props);
    this.requestLine1 = props.reqObject.requestLine1;
    this.womanName = props.reqObject.womanName;
    this.manName = props.reqObject.manName;
    this.day = props.reqObject.day;
    this.date = props.reqObject.date;
    this.year = props.reqObject.year;
    this.brideInitial = props.reqObject.brideInitial;
    this.groomInitial = props.reqObject.groomInitial;
    this.cityState = props.reqObject.cityState;
    this.phone = props.reqObject.phone;
    this.footerMessage1 = props.reqObject.footerMessage1;
    this.footerMessage2 = props.reqObject.footerMessage2;
    this.myRef = React.createRef();
    this.changed = props.reqObject.changed;
    this.isSideBySide = props.isSideBySide;
    this.baseSong = props.reqObject.baseSong;
    this.template = props.reqObject.template;
  }

   isupdate = 0;
  componentWillUpdate() {
    if (this.isSideBySide) {
      this.requestLine1 = this.props.reqObject.requestLine1;
      this.womanName = this.props.reqObject.womanName;
      this.manName = this.props.reqObject.manName;
      this.day = this.props.reqObject.day;
      this.date = this.props.reqObject.date;
      this.year = this.props.reqObject.year;
      this.cityState = this.props.reqObject.cityState;
      this.phone = this.props.reqObject.phone;
      this.footerMessage1 = this.props.reqObject.footerMessage1;
      this.footerMessage2 = this.props.reqObject.footerMessage2;
      this.myRef = React.createRef();
      this.changed = this.props.reqObject.changed;
      this.brideInitial = this.props.reqObject.womanName.charAt(0).capitalize();
      this.groomInitial =  this.props.reqObject.manName.charAt(0).capitalize();
      this.isSideBySide = this.props.isSideBySide;
      if(this.isupdate===0)
      {
      this.isupdate++;
      this.setState((prevState, props) => ({
        changed: !this.changed
      }));
     }
     else
      {
        this.isupdate=0;
      }
    }
  }

  render() {
    var bodyStyle = this.isSideBySide? "body-style-regular-save-date":"body-style-wreath-save-date";
    return (
        <div id="fullCard" style={{margin:"auto"}} className={bodyStyle} >
          <div >
            <div className="wreath-save-date">
              <h1 className="centerInitial-save-date">{this.brideInitial} | {this.groomInitial}</h1>
            </div>
            <div style={{ marginTop: "235px"}}>
            <InvitationText reqObject={this.props.reqObject} handleReqObject={this.handleReqObject} isSakura={this.isSakura}  />


            </div>
            
         
        </div>
    </div>

    );
  }
}

export default Wreath;